import {Dashboard} from "./lq_js_common/dashboard/dashboard";
import {TimePicker} from "./components/time_picker";
import {loadTrainingSnapshot, applyTrainingSnapshot} from "./training_snapshot";
import {loadTrainingCopy, initTrainingOverlay} from "./training_overlay";
import {ShaperHeaderDashlet} from "./dashlets/shaper/shaper_header";
import {ShaperFlowCountDashlet} from "./dashlets/shaper/shaper_flow_count";
import {ShaperActiveCircuits} from "./dashlets/shaper/shaper_active_circuit_count";
import {ShaperThroughput} from "./dashlets/shaper/shaper_throughput";
import {ShaperPackets} from "./dashlets/shaper/shaper_packets";
import {ShaperRetransmits} from "./dashlets/shaper/shaper_retransmits";
import {ShaperCake} from "./dashlets/shaper/shaper_cake";
import {ShaperRtt} from "./dashlets/shaper/shaper_rtt";
import {ShaperRttHisto} from "./dashlets/shaper/shaper_rtt_histo";
import {ShaperCombinedThroughput} from "./dashlets/shaper/shaper_combined_throughput";
import {ShaperCombinedRetransmits} from "./dashlets/shaper/shaper_combined_retransmits";
import {ShaperCombinedRtt} from "./dashlets/shaper/shaper_combined_rtt";
import {ShaperRttHeatmap} from "./dashlets/shaper/shaper_heatmap_rtt";
import {ShaperRetransmitHeatmap} from "./dashlets/shaper/shaper_heatmap_retransmits";
import {ShaperCapacityHeatmap} from "./dashlets/shaper/shaper_heatmap_capacity";
import {ShaperCpu} from "./dashlets/shaper/shaper_cpu";
import {ShaperMemory} from "./dashlets/shaper/shaper_memory";
import {ShaperAsnTopDownload} from "./dashlets/shaper/shaper_asn_top";
import {ShaperAsnTopUpload} from "./dashlets/shaper/shaper_asn_top_upload";
import {ShaperLiveBits} from "./dashlets/shaper/shaper_live_bits";
import {ShaperLivePackets} from "./dashlets/shaper/shaper_live_packets";
import {ShaperAsnMap} from "./dashlets/shaper/shaper_asn_map";
import {ShaperCombinedSankey} from "./dashlets/shaper/shaper_child_sankey";
import {ShaperTrafficOverviewGuide} from "./dashlets/shaper/shaper_traffic_overview_guide";
import {ShaperSiteRankings} from "./dashlets/shaper/shaper_site_rankings";
import {
    ExecutiveGlobalHeatmapDashlet,
    ExecutiveHelpersDashlet,
    ExecutiveQooHeatmapDashlet,
    ExecutiveRetransmitsHeatmapDashlet,
    ExecutiveRttHeatmapDashlet,
    ExecutiveSnapshotDashlet,
    ExecutiveUtilizationHeatmapDashlet,
} from "./dashlets/executive/executive_dashlets";
import {renderTrainingNavigation} from "./components/navbar";
import {createExplainController, setupLibbyExplainButton} from "./helpers/ai_explain";

const SNAPSHOT_URL = "/training/snapshots/shaper.json";
const COPY_URL = "/training/training_copy.json";

function forceDarkMode() {
    try {
        localStorage.setItem("theme", "dark");
    } catch (e) {
        // no-op
    }
    document.documentElement.setAttribute("data-bs-theme", "dark");
    document.body.classList.add("dark-mode");
}

function buildTagToTabIndex(layout) {
    const map = {};
    layout.tabs.forEach((tab, idx) => {
        tab.dashlets.forEach((dashlet) => {
            if (map[dashlet.tag] === undefined) {
                map[dashlet.tag] = idx;
            }
        });
    });
    const siteRankingsIndex = layout.tabs.findIndex((tab) => tab.name === "Site Rankings");
    if (siteRankingsIndex >= 0) {
        map.shaperInsightsRtt = siteRankingsIndex;
        map.shaperInsightsRxmit = siteRankingsIndex;
        map.shaperInsightsCapacityDown = siteRankingsIndex;
        map.shaperInsightsCapacityUp = siteRankingsIndex;
        map.shaperSiteRankings = siteRankingsIndex;
    }
    return map;
}

forceDarkMode();
window.nodeId = "0";

const defaultLayout = {
    version: 2,
    tabs: [
        {
            name: "Executive Summary",
            dashlets: [
                {tag: "executiveSnapshot", size: 12},
                {tag: "executiveGlobalHeatmap", size: 12},
                {tag: "executiveRttHeatmap", size: 6},
                {tag: "executiveRetransmitHeatmap", size: 6},
                {tag: "executiveUtilizationHeatmap", size: 6},
                {tag: "executiveQooHeatmap", size: 6},
                {tag: "executiveHelpers", size: 12},
            ]
        },
        {
            name: "Traffic Overview",
            dashlets: [
                {tag: "shaperTrafficOverviewGuide", size: 12},
                {tag: "shaperLiveBits", size: 6},
                {tag: "shaperLivePackets", size: 6},
                {tag: "shaperAsnTopDownload", size: 6},
                {tag: "shaperAsnTopUpload", size: 6},
                {tag: "shaperChildSankey", size: 6},
                {tag: "shaperChildSankeyUp", size: 6},
                {tag: "shaperAsnMap", size: 6},
                {tag: "shaperAsnMapUp", size: 6}
            ]
        },
        {
            name: "Shaper",
            dashlets: [
                {tag: "shaperActiveCircuits", size: 3},
                {tag: "shaperThroughput", size: 9},
                {tag: "shaperPackets", size: 6},
                {tag: "shaperRetransmits", size: 6},
                {tag: "shaperCake", size: 6},
                {tag: "shaperRtt", size: 6},
                {tag: "shaperRttHistogram", size: 4},
                {tag: "shaperCpu", size: 4},
                {tag: "shaperMemory", size: 4},
            ]
        },
        {
            name: "Children",
            dashlets: [
                {tag: "shaperCombinedThroughput", size: 12},
                {tag: "shaperCombinedRetransmits", size: 12},
                {tag: "shaperCombinedRtt", size: 12},
            ]
        },
        {
            name: "Heatmaps",
            dashlets: [
                {tag: "shaperHeatmapRtt", size: 4},
                {tag: "shaperHeatmapRxmit", size: 4},
                {tag: "shaperHeatmapCapacity", size: 4},
            ]
        },
        {
            name: "Site Rankings",
            dashlets: [
                {tag: "shaperSiteRankings", size: 12},
            ]
        }
    ],
    activeTab: 0
};

const dashletMenu = [
    {name: "Executive Snapshot", tag: "executiveSnapshot", size: 12},
    {name: "Executive Global Heatmap", tag: "executiveGlobalHeatmap", size: 12},
    {name: "Executive RTT Heatmap", tag: "executiveRttHeatmap", size: 6},
    {name: "Executive Retransmits Heatmap", tag: "executiveRetransmitHeatmap", size: 6},
    {name: "Executive Utilization Heatmap", tag: "executiveUtilizationHeatmap", size: 6},
    {name: "Executive QoO Heatmap", tag: "executiveQooHeatmap", size: 6},
    {name: "Executive Helper Views", tag: "executiveHelpers", size: 12},
    {name: "Traffic Overview Guide", tag: "shaperTrafficOverviewGuide", size: 12},
    {name: "Shaper Live Bits", tag: "shaperLiveBits", size: 6},
    {name: "Shaper Live Packets", tag: "shaperLivePackets", size: 6},
    {name: "Shaper Active Circuits", tag: "shaperActiveCircuits", size: 3},
    {name: "Shaper Throughput", tag: "shaperThroughput", size: 9},
    {name: "Shaper Packets", tag: "shaperPackets", size: 6},
    {name: "Shaper Retransmits", tag: "shaperRetransmits", size: 6},
    {name: "Shaper CAKE", tag: "shaperCake", size: 6},
    {name: "Shaper RTT", tag: "shaperRtt", size: 6},
    {name: "Shaper RTT Histogram", tag: "shaperRttHistogram", size: 4},
    {name: "Shaper Combined Throughput", tag: "shaperCombinedThroughput", size: 12},
    {name: "Shaper Combined TCP Retransmits", tag: "shaperCombinedRetransmits", size: 12},
    {name: "Shaper Combined Round-Trip Time", tag: "shaperCombinedRtt", size: 12},
    {name: "Shaper RTT Heatmap", tag: "shaperHeatmapRtt", size: 4},
    {name: "Shaper RTT Retransmits Heatmap", tag: "shaperHeatmapRxmit", size: 4},
    {name: "Shaper Capacity Heatmap", tag: "shaperHeatmapCapacity", size: 4},
    {name: "Shaper Top ASN (Download)", tag: "shaperAsnTopDownload", size: 6},
    {name: "Shaper Top ASN (Upload)", tag: "shaperAsnTopUpload", size: 6},
    {name: "Shaper ASN Map (Download)", tag: "shaperAsnMap", size: 12},
    {name: "Shaper ASN Map (Upload)", tag: "shaperAsnMapUp", size: 12},
    {name: "Shaper Child Sankey", tag: "shaperChildSankey", size: 6},
    {name: "Shaper Child Sankey (Upload)", tag: "shaperChildSankeyUp", size: 6},
    {name: "Shaper CPU Utilization", tag: "shaperCpu", size: 4},
    {name: "Shaper Memory Utilization", tag: "shaperMemory", size: 4},
    {name: "Site Rankings", tag: "shaperSiteRankings", size: 12},
];

function widgetFactory(widgetName, count) {
    let widget = null;
    switch (widgetName) {
        case "shaperHeader": widget = new ShaperHeaderDashlet(count); break;
        case "shaperTrafficOverviewGuide": widget = new ShaperTrafficOverviewGuide(count); break;
        case "shaperActiveCircuits": widget = new ShaperActiveCircuits(count); break;
        case "shaperLiveBits": widget = new ShaperLiveBits(count); break;
        case "shaperLivePackets": widget = new ShaperLivePackets(count); break;
        case "shaperThroughput": widget = new ShaperThroughput(count); break;
        case "shaperPackets": widget = new ShaperPackets(count); break;
        case "shaperRetransmits": widget = new ShaperRetransmits(count); break;
        case "shaperCake": widget = new ShaperCake(count); break;
        case "shaperRtt": widget = new ShaperRtt(count); break;
        case "shaperRttHistogram": widget = new ShaperRttHisto(count); break;
        case "shaperCombinedThroughput": widget = new ShaperCombinedThroughput(count); break;
        case "shaperCombinedRetransmits": widget = new ShaperCombinedRetransmits(count); break;
        case "shaperCombinedRtt": widget = new ShaperCombinedRtt(count); break;
        case "shaperHeatmapRtt" : widget = new ShaperRttHeatmap(count); break;
        case "shaperHeatmapRxmit" : widget = new ShaperRetransmitHeatmap(count); break;
        case "shaperHeatmapCapacity" : widget = new ShaperCapacityHeatmap(count); break;
        case "shaperAsnTopDownload" : widget = new ShaperAsnTopDownload(count); break;
        case "shaperAsnTopUpload" : widget = new ShaperAsnTopUpload(count); break;
        case "shaperAsnMap": widget = new ShaperAsnMap(count); break;
        case "shaperAsnMapUp": widget = new ShaperAsnMap(count, "upload"); break;
        case "shaperChildSankey": widget = new ShaperCombinedSankey(count); break;
        case "shaperChildSankeyUp": widget = new ShaperCombinedSankey(count, "upload"); break;
        case "shaperCpu": widget = new ShaperCpu(count); break;
        case "shaperMemory": widget = new ShaperMemory(count); break;
        case "shaperSiteRankings": widget = new ShaperSiteRankings(count); break;
        case "executiveSnapshot": widget = new ExecutiveSnapshotDashlet(count, "shaper"); break;
        case "executiveGlobalHeatmap": widget = new ExecutiveGlobalHeatmapDashlet(count, "shaper"); break;
        case "executiveRttHeatmap": widget = new ExecutiveRttHeatmapDashlet(count, "shaper"); break;
        case "executiveRetransmitHeatmap": widget = new ExecutiveRetransmitsHeatmapDashlet(count, "shaper"); break;
        case "executiveUtilizationHeatmap": widget = new ExecutiveUtilizationHeatmapDashlet(count, "shaper"); break;
        case "executiveQooHeatmap": widget = new ExecutiveQooHeatmapDashlet(count, "shaper"); break;
        case "executiveHelpers": widget = new ExecutiveHelpersDashlet(count, "shaper"); break;
        case "shaperFlowCount": widget = new ShaperFlowCountDashlet(count); break;
        default: {
            console.log("I don't know how to construct a widget of type [" + widgetName + "]");
            return null;
        }
    }
    return widget;
}

const dashboard = new Dashboard("dashboard", "training_shaperDashboard_v2", defaultLayout, widgetFactory, dashletMenu, false, "", false);
dashboard.build();

// Inline Libby insights strip. Training has no chatbot backend, so the
// controller renders the structured summary locally.
function explainableReadyDashlets() {
    return dashboard.dashlets.filter((d) => typeof d.canExplain === "function" && d.canExplain()
        && typeof d.isExplainReady === "function" && d.isExplainReady());
}
const explainController = createExplainController({
    dashboard,
    page: "shaper",
    getContext: () => ({node_id: String(window.nodeId)}),
    getExplainable: explainableReadyDashlets,
});
setupLibbyExplainButton(explainController);

window.timeGraphs = [];
window.timePicker = new TimePicker("timePicker");

(async () => {
    const tagToTabIndex = buildTagToTabIndex(defaultLayout);
    try {
        const snapshot = await loadTrainingSnapshot(SNAPSHOT_URL);
        if (snapshot?.ids?.node_id !== undefined) {
            window.nodeId = String(snapshot.ids.node_id);
        }
        if (snapshot?.data?.shaper_navigation) {
            const nav = snapshot.data.shaper_navigation;
            renderTrainingNavigation(nav.blob || [], window.nodeId, nav.is_flat || false);
        } else {
            renderTrainingNavigation([], window.nodeId, false);
        }
        const applied = applyTrainingSnapshot(dashboard, snapshot);
        if (applied === 0) {
            console.warn("Training snapshot is empty.");
        }
        explainController.markNeedsExplain();
    } catch (err) {
        console.error(err);
    }

    try {
        const copy = await loadTrainingCopy(COPY_URL);
        initTrainingOverlay({ copy, pageKey: "shaper", dashboard, tagToTabIndex });
    } catch (err) {
        console.error(err);
    }
})();
